import * as moment from "moment";

import { Profession } from "@teamprevent/common/adminUser/models";

import { Location } from "redux-little-router";

export const getUserDisplayName = (adminUser: Partial<AdminUserDetailModel>, ignoreEmail?: boolean, ignoreNameCheck?: boolean) => {
    if (adminUser.isLocumUser) {
        return adminUser.locumUserFullName;
    }

    if ((adminUser.firstName && adminUser.surname) || ignoreNameCheck) {
        return `${adminUser.firstName} ${adminUser.surname}`;
    }

    return ignoreEmail ? "" : adminUser.emailAddress;
};

export const getUserSortableName = (adminUser: Partial<AdminUserDetailModel>): string => {
    if (adminUser.isLocumUser) {
        return adminUser.locumUserFullName ?? "";
    }

    if (adminUser.firstName && adminUser.surname) {
        return `${adminUser.surname} ${adminUser.firstName}`;
    }

    return adminUser.emailAddress ?? "";
};

/**
 * @deprecated Prefer AdminUserDetailModel as the server only ever returns this
 */
export interface AdminUserListModel {
    readonly id: string;
    readonly emailAddress: string;
    readonly mobileNumber?: string;
    readonly listUpdated?: moment.Moment;
    readonly firstName?: string;
    readonly surname?: string;
    readonly isLocumUser?: boolean;
    readonly locumUserFullName?: string;
}

// We need to remove the optional fields from this and convert them to regular fields as the API returns them all see AdminUserDTO.cs
export interface AdminUserDetailModel {
    readonly id: string;
    readonly emailAddress: string;
    readonly mobileNumber?: string;
    readonly roles?: string[];
    readonly rolesNames?: string[];
    readonly profession?: Profession;
    readonly workingDays?: number[];
    readonly workingDayStartTime?: string;
    readonly workingDayEndTime?: string;
    readonly detailUpdated?: moment.Moment;
    readonly firstName?: string;
    readonly surname?: string;
    readonly qualification?: string;
    readonly isLocumUser?: boolean;
    readonly locumUserFullName?: string;
    readonly hasAssignedTasks?: boolean;
    readonly reportQA?: boolean;
}

/**
 * @deprecated Prefer AdminUserDetailModel as the server only ever returns this
 */
export type AdminUser = Partial<AdminUserListModel & AdminUserDetailModel> & { id: string }; // eslint-disable-line deprecation/deprecation
export type AdminUserInRedux = AdminUserDetailModel & { listUpdated: moment.Moment; detailUpdated: moment.Moment };

export interface AdminUserCreateModel {
    id: string;
    emailAddress: string;
    roles?: string[];
    profession?: Profession;
    mobileNumber: string;
    workingDays: number[];
    workingDayStartTime: string;
    workingDayEndTime: string;
    qualification: string;
    isLocumUser: boolean;
    locumUserFullName: string;
    reportQA: boolean;
}

export interface AdminUserEditModel {
    id: string;
    emailAddress: string;
    roles?: string[];
    profession?: Profession;
    mobileNumber: string;
    workingDays: number[];
    workingDayStartTime: string;
    workingDayEndTime: string;
    qualification: string;
    isLocumUser: boolean;
    locumUserFullName: string;
    reportQA: boolean;
}

export interface AdminUserState {
    readonly adminUsers: AdminUserInRedux[];
}

export type AppState = AdminUserState & { router: Location };
